import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchBundles } from "../../../actions/mine_craft/bundlesActions";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import ListTable from "./_partials/_ListTable";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import './style.scss';

export interface PropsInterface {
  appId: 1 | 2;
}

const LIMIT = 42;
const DEFAULT_ORDER_BY = 'prod';

const Bundles = ({ appId }: PropsInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const { pathname }    = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: appId,
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
        show_addons: true
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to'],
      { 'order_by': DEFAULT_ORDER_BY }
    );

    dispatch(fetchBundles(params));
  }, [searchParams, appId, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-bundles'>
      <PageHeader title='Bundles' />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={{
              defaultKey: DEFAULT_ORDER_BY,
              items: [
                { name: 'Environment', key: 'prod' },
                { name: 'Name', key: 'name' },
                { name: 'Created at', key: 'id' },
              ]
            }}
          />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <Edit />
    </PageLayout>
  );
}

export default Bundles;
